module.exports = "/images/blister-5.png";